let fs: any;
if (typeof window === 'undefined')
    fs = require('fs');
import { FileOperation } from "./FileOperation";

export class PackageService
{
    static MainJson: any = null;
    static ThisJson: any = null;
    static get(path: string): PackageService 
    {
        if (path)
        {
            const json = JSON.parse(fs.readFileSync(path, 'utf8'));
            if (json)
                return new PackageService(path, json);
        }
        throw new Error("Coundn't find package");
    }
    static getMain(): PackageService 
    {
        if (PackageService.MainJson)
            return new PackageService("", PackageService.MainJson);
        const paths = FileOperation.findUp('package.json');
        if (paths)
            return this.get(paths[paths.length - 1]);
        throw new Error("Coundn't find package");
    }
    static getThis(): PackageService 
    {
        if (PackageService.ThisJson)
            return new PackageService("", PackageService.ThisJson);
        const paths = FileOperation.findUp('package.json');
        if (paths)
            return this.get(paths[0]);
        throw new Error("Coundn't find package");
    }
    private path: string;
    private json: any;
    constructor(path: string, json: any)
    {
        this.json = json;
        this.path = path;
    }
    getPath(): string
    {
        return this.path;
    }
    getJson(): string
    {
        return this.json;
    }
    getName(): string
    {
        return this.json.name;
    }
    getTitle(): string
    {
        return this.json.title;
    }
    getDescription(): string
    {
        return this.json.description;
    }
    getIcon(): string
    {
        return this.json.icon;
    }
    getLogo(): string
    {
        return this.json.logo;
    }
    getVersion(): string
    {
        return this.json.version;
    }
}